module.exports = __webpack_public_path__ + "641d1ad1fa4cd1c7a488b30455902e2b.pdf";